import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { CartProvider } from './context/CartContext';


// Descomenta la siguiente línea para poblar la base de datos de sedes
// seedSedes();
// Descomenta la siguiente línea para poblar las categorías en las sedes
// seedCategories();
// Descomenta la siguiente línea para poblar los platos en Firestore
// seedDishes();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <CartProvider>
        <App />
      </CartProvider>
    </BrowserRouter>
  </React.StrictMode>
);
